import { Injectable } from '@angular/core';
import { CLocation } from '@models/imported/SagaSchema/CLocation';

export interface INavigationTool {
  name: string;
  icon: string;
  navigateTo(location: CLocation);
  position: number;
}

@Injectable({
  providedIn: 'root'
})
export class NavigationToolsProviderService {
  private _tools: INavigationTool[] = [];
  get tools(): INavigationTool[] {
    return this._tools;
  }

  constructor() {}

  add(tool: INavigationTool) {
    this._tools.push(tool);
    this._tools.sort((a, b) => a.position - b.position);
  }
}
